export default __webpack_public_path__ + "static/media/ToyDrive3.6566c51a.jpg";